import { css } from '@emotion/core';

export const SearchInputHeightCSS = css`
  height: 2.125rem;
`;
